import { render, staticRenderFns } from "./CardBodyHistory.vue?vue&type=template&id=36316da0&scoped=true&"
import script from "./CardBodyHistory.vue?vue&type=script&lang=js&"
export * from "./CardBodyHistory.vue?vue&type=script&lang=js&"
import style0 from "./CardBodyHistory.vue?vue&type=style&index=0&id=36316da0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36316da0",
  null
  
)

export default component.exports